import request from '../../../../util/APIUtils';
import { GATEWAY_BASE_URL } from '../../../../constants';

/**
 * Fetch program by id
 * @returns {Promise} Promise object represents the program
 */
export const fetchProgramById = async (programId) => {
  return request({
    url: `${GATEWAY_BASE_URL}/manage/programs/${programId}`,
    method: 'GET',
    throw400Error: true
  });
};

/**
 * Edits an existing program
 * @param {Integer} programId - program id to edit
 * @param {FormData} programData - Form data containing program details
 * @returns {Promise} Promise object represents the created program
 */
export const updateProgram = async (programData, programId) => {
  return request({
    url: `${GATEWAY_BASE_URL}/manage/programs/${programId}`,
    method: 'PUT',
    body: programData,
    throw400Error: true
  });
};

/**
 * Fetch all programs
 * @returns {Promise} Promise object represents the programs
 */
export const fetchPrograms = async (deliveryMethod) => {
  return request({
    url: `${GATEWAY_BASE_URL}/manage/programs?delivery_method=${deliveryMethod}`,
    method: 'GET',
    throw400Error: true
  });
};

/**
 * Creates a new program by sending a POST request to the backend.
 *
 * @async
 * @function createProgram
 * @param {FormData} programData - The form data containing program details.
 * @returns {Promise<Object>} A promise that resolves to the API response object.
 * The response will have the shape:
 * {
 *   status: 'SUCCESS' | 'FAILURE',
 *   payload: {
 *     [key: string]: any,
 *     errorMessage?: string,
 *     errorDetails?: string
 *   }
 * }
 *
 * The function does not throw on API errors. It always resolves with a response object,
 * even when the status is "FAILURE", allowing the caller to handle errors manually.
 */
export const createProgram = async (programData) => {
  try {
    // Always return the response (even if it's a failure)
    return await request({
      url: `${GATEWAY_BASE_URL}/manage/programs`,
      method: 'POST',
      body: programData,
      throw400Error: false // disable automatic throwing
    });

  } catch (err) {
    // Just in case something breaks (network, unexpected structure)
    return {
      status: 'FAILURE',
      payload: {
        errorMessage: 'Unexpected error',
        errorDetails: err?.message || 'Something went wrong',
      }
    };
  }
};


/**
 * Fetch courses
 * @param {string} searchInput Search input
 * @param {string} contentDeliveryMethod Content Delivery Method (D2L, ESSENTIAL_ED)
 * @param {string} contentProvider Content Provider (WRAP, ORIJIN, ESSENTIAL_ED)
 * @returns {Promise} Promise object represents the courses
 */
export const getCourses = (searchInput, contentDeliveryMethod, contentProvider) => {
  return request({
    url: `${GATEWAY_BASE_URL}/manage/programs/courses?search=${searchInput}&deliveryMethod=${contentDeliveryMethod}&contentProvider=${contentProvider}`,
    method: 'GET',
    throw400Error: true
  });

};